import { useNavigate } from 'react-router-dom';
const Back = () => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <button className="btn-back" onClick={handleBackClick}>
      <i className="bi bi-chevron-left"></i> Back
    </button>
  );
};
export default Back;